module.exports = __webpack_public_path__ + "img/master-cheff.jpg?2e3735073799c980e68cdb5567c3572e";